export default [
  'default',
  'roadTunnel',
  'railTunnel',
  'pedestrianBridge',
  'stadium',
  'busStop',
  'busStation',
  'controlRoom',
  'datacenter',
  'bridge',
  'office',
  'warehouse',
];
